<input
  type="text"
  class="form-control"
  [placeholder]="placeholder() | translate"
  [(ngModel)]="searchTerm"
  data-1p-ignore
  data-bwignore
  data-lpignore="true"
  data-form-type="other"
  autocomplete="off"
/>
